<div class="settings-container">
  <h2 id="modal-title">Settings</h2>

  <!-- App Registrations (Admin only) -->
  <div class="settings-card" *ngIf="user.role==='ADMIN'">
    <div class="card-header">
      <h4>App registrations</h4>
    </div>
    <div class="table-container">
      <table mat-table [dataSource]="dsAppRegistrations" class="full-width-table">

        <ng-container matColumnDef="Description">
          <th mat-header-cell *matHeaderCellDef> Description </th>
          <td mat-cell *matCellDef="let element"> {{element.description}} </td>
        </ng-container>

        <ng-container matColumnDef="Due Date Client Secret">
          <th mat-header-cell *matHeaderCellDef> Due Date Client Secret </th>
          <td mat-cell *matCellDef="let element"> {{element.dueDateClientSecret | date:'shortDate' }} </td>
        </ng-container>

        <ng-container matColumnDef="Tasks">
          <th mat-header-cell *matHeaderCellDef class="actions-column"> </th>
          <td mat-cell *matCellDef="let element" class="actions-column">
            <button *ngIf="element.userId != null" mat-icon-button (click)="openAppRegistration(element)">
              <mat-icon class="material-icons-outlined" matTooltip="Edit">edit</mat-icon>
            </button>
            <button *ngIf="element.userId != null" mat-icon-button (click)="deleteAppRegistration(element)">
              <mat-icon class="material-icons-outlined" matTooltip="Delete">delete</mat-icon>
            </button>
          </td>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="displayedARColumns"></tr>
        <tr mat-row *matRowDef="let row; columns: displayedARColumns;"></tr>
      </table>
    </div>
    <div class="card-actions">
      <button mat-raised-button color="primary" (click)="createAppRegistration()">New Registration</button>
    </div>
  </div>

  <!-- Linked Accounts -->
  <div class="settings-card">
    <div class="card-header">
      <h4>Calendars</h4>
    </div>
    <div class="table-container">
      <table mat-table [dataSource]="dataSource" class="full-width-table">

        <ng-container matColumnDef="Name">
          <th mat-header-cell *matHeaderCellDef> Name </th>
          <td mat-cell *matCellDef="let element"> {{element.description}} </td>
        </ng-container>

        <ng-container matColumnDef="Account type">
          <th mat-header-cell *matHeaderCellDef> Calendar type </th>
          <td mat-cell *matCellDef="let element"> {{element.accountTypeName}} </td>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
        <tr mat-row *matRowDef="let row; columns: displayedColumns;" (click)="openCalendarIntegrationModal(row)"
          class="clickable-row"></tr>
      </table>
    </div>
    <div class="card-actions">
      <button mat-raised-button color="primary" (click)="createNewCalendarIntegration()">Add calendar</button>
    </div>
  </div>

  <!-- General Settings Form -->
  <div class="settings-card">
    <div class="card-header">
      <h4>Preferences</h4>
    </div>
    <div class="settings-section">
      <mat-form-field appearance="outline" class="full-width">
        <mat-label>Timezone</mat-label>
        <mat-select [(ngModel)]="settings.timeZone" name="timezone" required>
          <div class="select-search-header">
            <input matInput placeholder="Search timezone..." (keyup)="filterTimezones($event)"
              (keydown)="$event.stopPropagation()" class="search-input">
          </div>
          <mat-option *ngFor="let tz of filteredTimeZones" [value]="tz.id">
            {{tz.displayName}}
          </mat-option>
        </mat-select>
      </mat-form-field>

      <div class="row">
        <mat-form-field appearance="outline" class="full-width">
          <mat-label>Look back (hours)</mat-label>
          <input matInput type="number" required min="0" [(ngModel)]="settings.lookbackHours"
            matTooltip="How many hours in the past should meetings remain visible?">
        </mat-form-field>

        <mat-form-field appearance="outline" class="full-width">
          <mat-label>Look ahead (hours)</mat-label>
          <input matInput type="number" required min="1" [(ngModel)]="settings.outlookHours"
            matTooltip="How far ahead do you want to see your meetings?">
        </mat-form-field>
      </div>

      <mat-form-field appearance="outline" class="full-width">
        <mat-label>Days done tasks stay visible</mat-label>
        <input matInput type="number" required min="1" [(ngModel)]="settings.keepDoneVisible"
          matTooltip="How long do you still want to see done tasks?">
      </mat-form-field>

      <div class="checkbox-group">
        <div class="checkbox-wrapper">
          <mat-checkbox class="custom-checkbox" color="primary" [(ngModel)]="settings.revisionsEnabled">Enable
            Revisions</mat-checkbox>
          <mat-icon class="info-icon" matTooltip="By enabling this you enable version history on your notes" matTooltipPosition="above">
            info_outline
          </mat-icon>

        </div>
        <div class="checkbox-wrapper">
          <mat-checkbox color="primary" [(ngModel)]="settings.showOnHold">Show column on hold with tasks</mat-checkbox>
        </div>
        <div class="checkbox-wrapper">
          <mat-checkbox color="primary" [(ngModel)]="settings.showWelcomePopup">Show welcome popup</mat-checkbox>
        </div>
      </div>
    </div>
  </div>

  <div class="actions">
    <button mat-raised-button color="primary" class="save-button" (click)="saveSettings()">Save Settings</button>
  </div>
</div>